import {Component, ElementRef, Input, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AdminService } from '../../../../../services/admin.service';
import {ReportsServiceService} from '../../../../../services/reports-service';
import {GenericModalService} from '../../../../../services/generic-modal.service';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FieldValueDetailComponent} from './field-value-details/field-value-detail.component';
import {Title} from "@angular/platform-browser";
import {HttpEventType} from '@angular/common/http';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-instance-history-details',
  templateUrl: './instance-history-details.component.html',
  styleUrls: ['./instance-history-details.component.css']
})
export class InstanceHistoryDetailsComponent implements OnInit {

  inscription: Subscription;
  bpInstanceId: number;
  timelineEvents;
  instanceHistoryDetail;
  fields;
  states;
  stateLifeCycles;
  availableStateLifeCycles;
  fieldValueDetailComponent: any = FieldValueDetailComponent;
  loadCompleted: boolean;
  errorMessage: string;
  hideEmptyFields: boolean;
  hideNotTrackableFields: boolean;
  showLifeCycleDetails: boolean;
  bsModalRef;
  attachments:[];
  hasAttachments;


  constructor(
    private formBuilder: FormBuilder,
    private admService: AdminService,
    private reportService: ReportsServiceService,
    private route: ActivatedRoute,
    private modalService: GenericModalService,
    private titleService:Title
  ) {
  }

  ngOnInit() {
    this.loadCompleted = false;
    this.inscription = this.route.params.subscribe(params => {
      this.bpInstanceId = params['id'];
      this.titleService.setTitle(`Histórico de Execução da Instância ${this.bpInstanceId}`);
      this.loadAttachments();
      this.loadStateLifeCycles();
      this.hideEmptyFields = false;
      this.hideNotTrackableFields = false;
      this.showLifeCycleDetails = true;
    });
  }

  loadStateLifeCycles() {
    this.reportService.getStatesLifeCycles()
      .subscribe(
        result => {
          this.availableStateLifeCycles = result;
          this.loadTimelineEvents();
        }, error1 => {
          this.errorMessage = error1;
        }
      );
  }

  loadAttachments(){
    this.errorMessage = "";
    this.reportService.getAttachmentsByInstance(this.bpInstanceId)
      .subscribe(
        result => {
          this.attachments = result;
          this.hasAttachments = result && result.length > 0;
        }, error => {
          this.errorMessage = error;
        }
      );
  }

  loadTimelineEvents() {
    this.errorMessage = '';
    this.reportService.getTimelineEvents(this.bpInstanceId)
      .subscribe(
        result => {
          this.timelineEvents = result;
          let lastTimelineEvent = this.timelineEvents && this.timelineEvents.length && this.timelineEvents[this.timelineEvents.length - 1];
          this.getInstanceHistoryDetails(lastTimelineEvent);
        }, error => {
          this.loadCompleted = true;
          this.errorMessage = error;
          console.error(error)
        }
      );
  }

  getInstanceHistoryDetails(lastTimelineEvent) {
    this.errorMessage = '';
    this.fields = [];
    this.instanceHistoryDetail = undefined;
    this.reportService.getInstanceHistoryDetails(this.bpInstanceId, lastTimelineEvent.executionOrder, lastTimelineEvent.version)
      .subscribe(
        result => {
          this.instanceHistoryDetail = result;
          this.loadCompleted = true;
          if (result){
            result.fields.forEach(f => {
              this.fields.push(new FieldWrapper(f));
            });

            this.states = [];
            this.stateLifeCycles = [];

            let currentState;
            result.stateLifeCycles.forEach(lifeCycle => {
              let isStateChange = false;

              if (!currentState || (lifeCycle.stateCount !== currentState.stateCount)) {
                isStateChange = (currentState !== undefined); // O primeiro estado não representa mudança de estado
                currentState = new StateWrapper(lifeCycle.stateId, lifeCycle.stateName, lifeCycle.executionOrder, lifeCycle.stateCount);
                this.states.push(currentState);
              }

              let lifeCycleWrapper = new StateLifeCycleWrapper(lifeCycle, undefined);
              this.stateLifeCycles.push(lifeCycleWrapper);
              currentState.lifeCycles.push(lifeCycleWrapper);

              lifeCycle.fieldValues.forEach(fieldValue => {
                let field = this.fieldById(fieldValue.id);
                if (field)
                  field.PushValue(fieldValue, isStateChange);
              });

            });
          }
        },
          error => {
            this.loadCompleted = true;
            this.errorMessage = error;
            console.error(error)
        }
      );
  }

  fieldById(fieldId: number){
    let result = this.fields.filter(f => f.id == fieldId);
    if (result && result.length == 1)
      return result[0];
    return undefined;
  }

  translateStateLifeCycleValue(value){
    let translatedValue = this.availableStateLifeCycles.filter(a => a.value == value);
    if (translatedValue && translatedValue.length == 1)
      return translatedValue[0].translatedName;
    return value;
  }

  onEventClick(event: any) {
    this.loadCompleted = false;
    this.getInstanceHistoryDetails(event);
  }

  onDetailsClick(field, fieldValue) {
    this.modalService.showObjModal(this.fieldValueDetailComponent, `Conteúdo do campo ${field.name}`,
      fieldValue);
  }

  openLegendModal(template: TemplateRef<any>) {
    this.bsModalRef = this.modalService.showObjModalWithTemplate(template, {}, 'modal-md');
  }

  onCloseModal() {
    this.bsModalRef.hide();
  }

  openAttachModal(template: TemplateRef<any>) {
    this.bsModalRef = this.modalService.showObjModalWithTemplate(template, {});
  }

  downloadAttachment(file) {
    this.reportService.getAttachmentContent(file.id, file.name).subscribe(
      data => {
        switch (data.type) {
          case HttpEventType.DownloadProgress:
            console.log('Download status: ' + Math.round((data.loaded / data.total) * 100) + '%');
            break;
          case HttpEventType.Response:
            const downloadedFile = new Blob([data.body], { type: data.body.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            //a.download = encodeURIComponent(file.name);
            a.download = file.name;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
        }
      },
      error => {
        const errorMsg = `Erro ao realizar o download do anexo da instância: ${error}`;
        this.errorMessage = errorMsg;
        console.log(errorMsg);
      }
    );
  }

  downloadPdf(onlyCurrentHistory: boolean) {
    let current_date = new Date();
    let offset = current_date.getTimezoneOffset();
    let currentUrl = location.href;
    let bpName = this.instanceHistoryDetail.businessProcessName;
    let sDate = formatDate(new Date(),'ddMMyyyy',"pt-BR");
    let fileName = `${bpName}${this.bpInstanceId}${sDate}.pdf`;
    this.reportService.getInstanceHistoryPdf(this.bpInstanceId, bpName, currentUrl, onlyCurrentHistory,offset).subscribe(
      data => {
        switch (data.type) {
          case HttpEventType.DownloadProgress:
            console.log('Download pdf status: ' + Math.round((data.loaded / data.total) * 100) + '%');
            break;
          case HttpEventType.Response:
            const downloadedFile = new Blob([data.body], { type: data.body.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            //a.download = encodeURIComponent(file.name);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
        }
      },
      error => {
        const errorMsg = `Erro ao realizar o download do pdf da instância: ${error}`;
        this.errorMessage = errorMsg;
        console.log(errorMsg);
      }
    );
  }
}


export class FieldWrapper {
  MAX_VISIBLE_CONTENT_LENGTH = 50;

  isTrackable:boolean;
  isEmpty:boolean;
  name:string;
  shortName:string;
  id:number;
  displayName:string;
  values;

  constructor(field) {
    this.isTrackable = field.isTrackable;
    this.isEmpty = field.isEmpty;
    this.name = field.name;
    this.shortName = field.name.substring(0, 40);
    this.id = field.id;
    this.displayName = field.displayName;
    this.values = [];
  }

  _augmentFieldValue(fieldValue, previousValue, isStateChange) {
    let hasChanged = previousValue && previousValue.value != fieldValue.value;

    let fullValue = fieldValue.value;
    if (fullValue && fullValue.length > this.MAX_VISIBLE_CONTENT_LENGTH) {
      fieldValue.hasZoomableContent = true;
      fieldValue.shortenedValue = fullValue.substring(0, this.MAX_VISIBLE_CONTENT_LENGTH);
    } else {
      fieldValue.hasZoomableContent = false;
      fieldValue.shortenedValue = fullValue;
    }

    fieldValue.cssClass = (isStateChange && 'stateChange' || '')
      + (hasChanged && ' valueChange' || '')
      + (fieldValue.hasZoomableContent && ' zoomable' || '');
  };

  public PushValue(fieldValue, isStateChange) {
    this._augmentFieldValue(fieldValue, (this.values.length && this.values[this.values.length - 1]), isStateChange);
    this.values.push(fieldValue);
  };
}

export class StateWrapper {
  id:number;
  executionOrder:number;
  name:string;
  stateCount:number;
  lifeCycles;

  constructor(id, name, executionOrder, stateCount) {
    this.id = id;
    this.executionOrder = executionOrder;
    this.name = name;
    this.stateCount = stateCount;
    this.lifeCycles = [];
  }
}

export class StateLifeCycleWrapper {
  modifiedBy:string;
  runtimeHostName:string;
  kind;
  modifyDate;
  isStateChange:boolean;
  errorSummary:string;
  errorDetail:string;
  warningMessage:string;
  stateCount:number;
  executionOrder:number;

  constructor(lifeCycle, isStateChange: boolean) {
    this.modifiedBy = lifeCycle.modifiedBy;
    this.runtimeHostName = lifeCycle.runtimeHostName;
    this.kind = lifeCycle.stateLifeCycle;
    this.modifyDate = lifeCycle.stateLifeCycleModifyDate
    this.isStateChange = isStateChange;
    this.errorSummary = lifeCycle.errorSummary;
    this.errorDetail = lifeCycle.errorDetail;
    this.warningMessage = lifeCycle.warningMessage;
    this.stateCount = lifeCycle.stateCount;
    this.executionOrder = lifeCycle.executionOrder;
  }
}


